import {
  IconAd,
  IconBrandMeta,
  IconBrandGoogle,
  IconBrandLinkedin,
  IconBrandTiktok,
  IconBrandSpotify,
} from '@tabler/icons-vue';
import type { Component } from 'vue';

export interface CampaignProviderMeta {
  icon: Component;
  color: string;
  label: string;
}

export const CAMPAIGN_PROVIDER_META: Record<string, CampaignProviderMeta> = {
  adform: { icon: IconAd, color: '#0b2a39', label: 'Display' },
  facebook: { icon: IconBrandMeta, color: '#1877F2', label: 'Meta' },
  googleads_search_ad: { icon: IconBrandGoogle, color: '#4285F4', label: 'Google Ads (Search)' },
  googleads_display_ad: { icon: IconBrandGoogle, color: '#4285F4', label: 'Google Ads (Display)' },
  googleads_display_ad_demand_gen: { icon: IconBrandGoogle, color: '#4285F4', label: 'Google Ads (Display)' },
  linkedin: { icon: IconBrandLinkedin, color: '#0A66C2', label: 'LinkedIn' },
  tik_tok: { icon: IconBrandTiktok, color: '#000000', label: 'TikTok' },
  spotify: { icon: IconBrandSpotify, color: '#1ed760', label: 'Spotify' },
};

export function getCampaignProviderMeta(provider: string): CampaignProviderMeta {
  return CAMPAIGN_PROVIDER_META[provider] ?? { icon: IconAd, color: '#6b7280', label: provider };
}
